<div class="header">
  <ng-container *ngIf="options.buttons?.left as leftButton">
    <button
      *ngIf="leftButton.visible()"
      tuiButton
      class="header__button header__button_left"
      type="button"
      appearance="link"
      size="s"
      [iconStart]="leftButton.icon"
      [title]="leftButton.label ?? ''"
      (click)="leftButton.action()"
    >
      {{ leftButton.label }}
    </button>
  </ng-container>

  <div class="title text_bold text_size-m">{{ options.title }}</div>

  <ng-container *ngIf="options.buttons?.right as rightButton">
    <button
      *ngIf="rightButton.visible()"
      tuiButton
      class="header__button header__button_right"
      type="button"
      appearance="link"
      size="s"
      [iconStart]="rightButton.icon"
      [title]="rightButton.label ?? ''"
      (click)="rightButton.action()"
    >
      {{ rightButton.label }}
    </button>
  </ng-container>
</div>
